import dayjs from 'dayjs';

export const getFormatedDietEntryString = ({
    dateFrom,
    dateTo,
    institutionDiet,
}: {
    dateFrom: string;
    dateTo?: string | undefined;
    institutionDiet: {
        id: string;
        name: string;
    };
}) => {
    const dateFromString = dayjs(dateFrom).format('DD/MM/YYYY');
    const dateToString = dateTo ? dayjs(dateTo).format('DD/MM/YYYY') : 'Obecnie';

    return `${institutionDiet?.name ?? 'Brak diety'}: ${dateFromString} - ${dateToString}`;
};
